import TagRuleBase from './TagRuleBase';
import { observable } from 'mobx';
import { ElasticSearchFuzzyQueryRuleResult, RuleError } from '../types';
import PipelineStep from '../../pipeline_base/models/PipelineStep';
import PipelineStepType from '../types/PipelineStepType';
import { RuleStatus } from './RuleBase';

export default class ElasticSearchFuzzyQueryRule extends TagRuleBase<
    ElasticSearchFuzzyQueryRule,
    ElasticSearchFuzzyQueryRuleResult
> {
    @observable
    value: string;

    @observable
    fuzziness?: string;

    @observable
    prefixLength: number;

    @observable
    transpositions: boolean;

    @observable
    excludedBlockTypes: string[];

    constructor(
        id: string | null,
        projectId: string | null,
        name: string,
        tagId: string | null,
        tag: string,
        value: string,
        prefixLength: number,
        transpositions: boolean,
        pipeline: PipelineStep<PipelineStepType>[] = [],
        groupId: string | null,
        fuzziness?: string,
        updateDate?: Date,
        priority: number = 1,
        description?: string,
        state?: 'Enabled' | 'Disabled',
        status: RuleStatus = RuleStatus.Valid,
        overridePriority: boolean = false,
        excludedBlockTypes: string[] = [],
        errors?: RuleError[]
    ) {
        super(
            id,
            projectId,
            name,
            tagId,
            tag,
            'ElasticSearchFuzzyQueryRule',
            pipeline,
            groupId,
            updateDate,
            priority,
            description,
            state,
            status,
            overridePriority,
            errors
        );
        this.value = value;
        this.fuzziness = fuzziness;
        this.prefixLength = prefixLength;
        this.transpositions = transpositions;
        this.excludedBlockTypes = excludedBlockTypes || [];
    }

    clone(): ElasticSearchFuzzyQueryRule {
        return new ElasticSearchFuzzyQueryRule(
            this.id,
            this.projectId,
            this.name,
            this.tagId,
            this.tag,
            this.value,
            this.prefixLength,
            this.transpositions,
            this.clonePipeline(),
            this.groupId,
            this.fuzziness,
            this.updateDate,
            this.priority,
            this.description,
            this.state,
            this.status,
            this.overridePriority,
            this.excludedBlockTypes
        );
    }

    validateState(): string[] {
        if (!this.name || !this.value || !this.tag) {
            return ['Fill all fields'];
        }

        const errors = this.validatePipeline();

        return errors;
    }

    toJson(): ElasticSearchFuzzyQueryRuleResult {
        const json: ElasticSearchFuzzyQueryRuleResult = {
            ruleType: this.ruleType,
            id: this.id,
            groupId: this.groupId,
            name: this.name,
            value: this.value,
            fuzziness: this.fuzziness,
            prefixLength: this.prefixLength,
            transpositions: this.transpositions,
            tagId: this.tagId,
            tag: this.tag,
            pipeline: this.pipelineToJSON(),
            projectId: this.projectId,
            priority: this.priority,
            description: this.description,
            state: this.state,
            status: this.status,
            overridePriority: this.overridePriority,
            excludedBlockTypes: this.excludedBlockTypes
        };

        return json;
    }
}
